import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { apiRequest } from "../apiService/allapi";

const Banner = () => {
  const API_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

  const [banner, setBanner] = useState([]);

  const fetchBanner = async () => {
    try {
      const type = window.innerWidth < 768 ? "mobile" : "desktop";

      const res = await apiRequest(`/Category/banner/list?type=${type}`);

      setBanner(res?.data?.data || []);
    } catch (error) {
      console.log("Banner Fetch Error:", error);
      setBanner([]);
    }
  };

  useEffect(() => {
    fetchBanner();
  }, []);

  // Next Arrow
  function SampleNextArrow(props) {
    const { className, onClick } = props;

    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-next slick-arrow`}
      >
        <i className="ph ph-caret-right"></i>
      </button>
    );
  }

  // Prev Arrow
  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow`}
      >
        <i className="ph ph-caret-left"></i>
      </button>
    );
  }

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,

    slidesToShow: 1,
    slidesToScroll: 1,

    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="banner">
      <div className="container container-lg">
        <div className="banner-item rounded-24 overflow-hidden position-relative arrow-center">
          <div className="banner-slider">
            <Slider {...settings}>
              {banner.map((item, index) => (
                <div key={index}>
                  <div className="banner-slider__item">
                    <img
                      // src={`${process.env.REACT_APP_BANNER_BASE_URL}${item.slideImage}`}
                      src={`${API_BASE_URL}${item.slideImage}`}
                      // src={item.slideImage}

                      alt="banner"
                    />
                  </div>
                  <div className="banner-content text-center">
                    <h6>{item.title}</h6>

                    <Link to="/shop" className="btn btn-main rounded-pill">
                      Explore Shop
                    </Link>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
